import React from 'react';
import { Route } from 'react-router-dom';
import { NavHashLink as Link } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';


function ListItemLink({ to, ...rest }) {
  return (
    <Route
      path={to}
      exact
      strict
      children={({ match, location }) => (
        <li
          className={(match || (`${location.pathname}${location.hash}` === to)) ? 'active' : null}
        >
          <Link to={to} {...rest} />
        </li>
      )}
    />
  );
}

function HelpTOC() {
  const { t } = useTranslation('help');
  return (
    <nav id="toc">
      <ul>
        <ListItemLink to="/help/about">{t('About the service')}</ListItemLink>
        <ul>
          <ListItemLink to="/help/about#safety">{t('Safety information')}</ListItemLink>
          <ListItemLink to="/help/about#label">{t('Product information')}</ListItemLink>
        </ul>
        <ListItemLink to="/help/views">{t('Available views')}</ListItemLink>
        <ul>
          <ListItemLink to="/help/views#agp">{t('AGP Report')}</ListItemLink>
          {/*
          <ListItemLink to="/help/views#insulin">Insulin</ListItemLink>
          <ListItemLink to="/help/views#nutrition">Nutrition</ListItemLink>
          <ListItemLink to="/help/views#exercise">Exercise</ListItemLink>
          <ListItemLink to="/help/views#diary">Diary</ListItemLink>
          */}
          <ListItemLink to="/help/views#day">{t('Daily view')}</ListItemLink>
        </ul>
        <ListItemLink to="/help/features">{t('Features')}</ListItemLink>
        <ul>
          <ListItemLink to="/help/features#agp">{t('AGP Report')}</ListItemLink>
          <ListItemLink to="/help/features#day">{t('Daily view')}</ListItemLink>
          <ListItemLink to="/help/features#settings">{t('Notifications and settings')}</ListItemLink>
        </ul>
        <ListItemLink to="/help/interpretation">{t('Interpretation')}</ListItemLink>
        <ul>
          <ListItemLink to="/help/interpretation#balance">{t('Learn from the graphs')}</ListItemLink>
          <ListItemLink to="/help/interpretation#images">{t('Add meal photos')}</ListItemLink>
          <ListItemLink to="/help/interpretation#exercise">{t('Add exercise information')}</ListItemLink>
          <ListItemLink to="/help/interpretation#oura">{t('Add sleep and recovery information')}</ListItemLink>
        </ul>
        <ListItemLink to="/help/practitioner">{t('For practitioners')}</ListItemLink>
        <ul>
          <ListItemLink to="/help/practitioner#startup">{t('Launch from the EHR')}</ListItemLink>
          <ListItemLink to="/help/practitioner#dataAccess">{t('Ask for permissions')}</ListItemLink>
          <ListItemLink to="/help/practitioner#dataUsage">{t('Inspect the graphs')}</ListItemLink>
          <ListItemLink to="/help/practitioner#toPatientSystem">{t('Copy information to the EHR')}</ListItemLink>
        </ul>
      </ul>
    </nav>
  );
}

export default HelpTOC;
